// @flow
const hasPermission = (scopes: Array<string> = [],permissions = []): boolean => {
	const checkPermission = (permission) => permissions.includes(permission);
	return scopes.some(checkPermission);
};

// eslint-disable-next-line import/prefer-default-export
export { hasPermission }